export default __webpack_public_path__ + "images/de16addd3bcb2012638b97cf2eb95f92.svg";